export default "__VITE_ASSET__BfjlUok$__"